<template>
  <div>
    <transition
      name="fade"
      mode="out-in"
    >
      <RouterView class="pb-15" />
    </transition>
  </div>
</template>

<script lang="ts">
export default {
  name: 'TheMainContent',
};
</script>

<script setup lang="ts">
</script>
